module.exports = __webpack_public_path__ + "img/searchIcon.fb9d72d7.svg";